var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "convert_svg__a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27.83 27.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "convert_svg__c",
    x1: 503.57,
    y1: -549.52,
    x2: 644.09,
    y2: -549.52,
    gradientTransform: "translate(-32.47 -30.26) scale(.07 -.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "convert_svg__d",
    x1: -279.31,
    y1: 291.36,
    x2: -138.79,
    y2: 291.36,
    gradientTransform: "translate(2.04 -4.49) rotate(-180) scale(.07 -.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cd4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4690ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "convert_svg__b",
    "data-name": "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.52,9.7h-6.32s2.55-2.55,2.55-2.55c.18-.18.27-.41.27-.66s-.1-.49-.27-.66c-.37-.37-.96-.37-1.33,0l-4.14,4.14c-.18.18-.28.41-.28.66s.1.49.28.66l4.17,4.17c.37.36.96.36,1.33,0,.18-.18.28-.41.28-.66s-.1-.49-.28-.66l-2.56-2.56h6.3c.25,0,.49-.09.66-.27.18-.18.28-.41.28-.66,0-.52-.42-.94-.94-.94h0Z",
    style: {
      fill: "url(#convert_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.31,18.12h6.32s-2.55,2.55-2.55,2.55c-.18.18-.27.41-.27.66s.1.49.27.66c.37.37.96.37,1.33,0l4.14-4.14c.18-.18.28-.41.28-.66s-.1-.49-.28-.66l-4.17-4.17c-.37-.36-.96-.36-1.33,0-.18.18-.28.41-.28.66s.1.49.28.66l2.56,2.56h-6.3c-.25,0-.49.09-.66.27-.18.18-.28.41-.28.66,0,.52.42.94.94.94h0Z",
    style: {
      fill: "url(#convert_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.91,0C6.24,0,0,6.24,0,13.91s6.24,13.91,13.91,13.91,13.91-6.24,13.91-13.91S21.59,0,13.91,0Zm0,26.04c-6.69,0-12.13-5.44-12.13-12.13S7.23,1.79,13.91,1.79s12.13,5.44,12.13,12.13-5.44,12.13-12.13,12.13Z",
    style: {
      fill: "#f7f7f7"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.c190a52e3bee2ff5cd265e00b348c887.svg";
export { ForwardRef as ReactComponent };